import {
  ADD_EMPLOYEE_START,
  ADD_EMPLOYEE_SUCCESS,
  ADD_EMPLOYEE_FAILURE,
  ADD_EMPLOYEE_RESET,
  GET_EMPLOYEE_START,
  GET_EMPLOYEE_SUCCESS,
  GET_EMPLOYEE_FAILURE,
  GET_EMPLOYEE_RESET,
  DELETE_EMPLOYEE_START,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_FAILURE,
  DELETE_EMPLOYEE_RESET,
  EDIT_EMPLOYEE_START,
  EDIT_EMPLOYEE_SUCCESS,
  EDIT_EMPLOYEE_FAILURE,
  EDIT_EMPLOYEE_RESET,
  VERIFY_EMPLOYEE_START,
  VERIFY_EMPLOYEE_SUCCESS,
  VERIFY_EMPLOYEE_FAILURE,
  GET_EMPLOYEE_PROFILE_START,
  GET_EMPLOYEE_PROFILE_SUCCESS,
  GET_EMPLOYEE_PROFILE_FAILURE,
  GET_EMPLOYEE_PROFILE_RESET,
  VIEW_EMPLOYEE_START,
  VIEW_EMPLOYEE_FAILURE,
  VERIFY_EMPLOYEE_RESET,
  VIEW_EMPLOYEE_SUCCESS,
  MY_EMPLOYEE_SUCCESS,
  MY_EMPLOYEE_FAILURE,
  MY_EMPLOYEE_RESET,
  TRANSFER_EMP_ASSETS_SUCCESS,
  TRANSFER_EMP_ASSETS,
  TRANSFER_EMP_ASSETS_FAILED,
} from "./actiontype"

const initialState = {
  employees: [],
  SingleView: {},
  error: null,
  AddEmployeeLoading: false,
  isEmployeeAdded: false,
  employeeMsg: "",
  deletingEmployee: false,
  deleteemployeeMsg: "",
  verifyEmpLoading: null,
  success: false,
  EmpotpVerified: false,
  otploading: false,
  otpResponseMessage: "",
  otpVerified: false,
  employeeProfile: {},
  employeeData: {},
  Users: [],
  loading: false,
}

const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_EMPLOYEE_START:
      return {
        ...state,
        AddEmployeeLoading: true,
        isEmployeeAdded: false,
        error: null,
      }
    case ADD_EMPLOYEE_SUCCESS:
      return {
        ...state,
        employeeMsg: action.payload.message,
        AddEmployeeLoading: false,
        isEmployeeAdded: true,
        employeeMsg: action.payload.message,
      }
    case ADD_EMPLOYEE_FAILURE:
      return {
        ...state,
        AddEmployeeLoading: false,
        isEmployeeAdded: false,
        error: action.payload.message,
      }

    case MY_EMPLOYEE_SUCCESS:
      return {
        ...state,
        Users: action.payload,
      }

    case MY_EMPLOYEE_FAILURE:
      return {
        ...state,
        error: action.payload.message,
      }

    case MY_EMPLOYEE_RESET:
      return {
        ...state,
        Users: [],
      }

    case ADD_EMPLOYEE_RESET:
      return {
        employees: [],
        isEmployeeAdded: false,
        error: null,
        AddEmployeeLoading: false,
        employeeMsg: "",
      }

    case GET_EMPLOYEE_START:
      return {
        ...state,
        AddEmployeeLoading: true,
        error: null,
        employeeMsg: "",
      }

    case GET_EMPLOYEE_SUCCESS:
      return {
        ...state,
        AddEmployeeLoading: false,
        employees: action.payload.data,
     //   employeeMsg: action.payload.message,
      }

    case GET_EMPLOYEE_FAILURE:
      return {
        ...state,
        AddEmployeeLoading: false,
        error: action.payload.message,
      }
    case GET_EMPLOYEE_RESET:
      return {
        employees: [],
        error: null,
        AddEmployeeLoading: false,
        employeeMsg: "",
      }

    //view-Employee

    case VIEW_EMPLOYEE_START:
      return {
        ...state,
        AddEmployeeLoading: true,
        error: null,
        employeeMsg: "",
      }

    case VIEW_EMPLOYEE_SUCCESS:
      return {
        ...state,
        AddEmployeeLoading: false,
        SingleView: action.payload.data,
       // employeeMsg: action.payload.message,
      }

    case VIEW_EMPLOYEE_FAILURE:
      return {
        ...state,
        AddEmployeeLoading: false,
        error: action.payload.message,
      }
    case VERIFY_EMPLOYEE_RESET:
      return {
        SingleView: [],
        error: null,
        AddEmployeeLoading: false,
        employeeMsg: "",
      }
    // for delete

    case DELETE_EMPLOYEE_START:
      //console.log("employee")
      return {
        ...state,
        deletingEmployee: true,
        error: null,
        deleteemployeeMsg: "",
      }
    case DELETE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        deletingEmployee: false,
        error: null,
        deleteemployeeMsg: action.payload.message,
      }
    case DELETE_EMPLOYEE_FAILURE:
      return {
        ...state,
        deletingEmployee: false,
        error: action.payload,
      }
    case DELETE_EMPLOYEE_RESET:
      return {
        employess: [],
        ...state,
        deletingEmployee: false,
        error: null,
        deleteemployeeMsg: "",
      }
    case EDIT_EMPLOYEE_START:
      return {
        ...state,
        loading: true,
        error: null,
        employeeMsg: "",
      }
    case EDIT_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        employeeMsg: action.payload.message,
      }
    case EDIT_EMPLOYEE_FAILURE:
      return {
        ...state,
        AddEmployeeLoading: false,
        error: action.payload.message,
        loading: false,
      }
    case EDIT_EMPLOYEE_RESET:
      return {
        error: null,
        AddEmployeeLoading: false,
        employeeMsg: "",
        loading: false,
      }

    // verify employee

    case VERIFY_EMPLOYEE_START:
      return {
        ...state,
        verifyEmpLoading: true,
        success: false,
        verifyError: null,
        EmpVerified: false,
      }

    case VERIFY_EMPLOYEE_SUCCESS:
      console.log(action.payload.message)
      return {
        ...state,
        verifyEmpLoading: false,
        EmpResponseMessage: action.payload.message,
        EmpotpVerified:
          action.payload.message === "Employee verified and Activated"
            ? true
            : false,
        success: true,
        error: null,
      }

    case VERIFY_EMPLOYEE_FAILURE:
      console.log(action.payload)
      return {
        ...state,
        // user: null,
        verifyEmpLoading: false,
        success: false,
        error: action.payload.message,
        EmpotpVerified: false,
      }
    case GET_EMPLOYEE_PROFILE_START:
      return {
        ...state,
        error: null,
        loading: true,
      }
    case GET_EMPLOYEE_PROFILE_SUCCESS:
      console.log(action.payload)
      return {
        ...state,
        error: null,
        employeeProfile: action.payload.employeeData,
        employeeData: action.payload.userData,
        loading: false,
      }
    case GET_EMPLOYEE_PROFILE_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_EMPLOYEE_PROFILE_FAILURE:
      return {
        ...state,
        error: null,
      }
    case TRANSFER_EMP_ASSETS:
      return {
        ...state,
        loading: true
      }
    case TRANSFER_EMP_ASSETS_SUCCESS:
      return {
        ...state,
        employeeMsg: action.payload,
        loading: false
      }
    case TRANSFER_EMP_ASSETS_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}
export default employeeReducer
